<template>
  <div class="home-three-map">
    <!-- <div class="rightMain">
      <div class="title">跳转操作</div>
      <div class="cont">
        <ul>
          <li v-for="(item, index) in objList" @click="cameraPos(item)">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="title">其他操作</div>
      <div class="cont">
        <ul>
          <li @click="rotationChange">{{ rotation }}</li>
          <li @click="columnChange">添加光柱</li>
          <li @click="delAllChange">删除所有</li>
          <li @click="delMarkChange">删除美国标记点</li>
        </ul>
      </div>
      <div class="title">重置操作</div>
      <div class="cont">
        <ul>
          <li @click="reset">初始化数据</li>
          <li @click="addLine">添加飞线</li>
        </ul>
      </div>
    </div> -->

    <div id="moduleUl" v-if="isShow" class="module-ul">
      <div  :class="active == 0 ? 'module-li module-active' : 'module-li'" @click="handleLi(0)">
        <div
          class="module-mask"
        ></div>
        <img class="module-img" src="@/assets/buttonList/comprehensive-logo.png" alt="" />
        <span class="module-text">综合</span>
      </div>
      <div :class="active == 1 ? 'module-li module-active' : 'module-li'" @click="handleLi(1)">
        <div
          class="module-mask"
        ></div>
        <img class="module-img" src="@/assets/buttonList/certificate-logo.png" alt="" />
        <span class="module-text">证书</span>
      </div>
      <div :class="active == 2 ? 'module-li module-active' : 'module-li'" @click="handleLi(2)">
        <div
          class="module-mask"
        ></div>
        <img class="module-img" src="@/assets/buttonList/router-logo.png" alt="" />
        <span class="module-text">路由</span>
      </div>
      <div :class="active == 3 ? 'module-li module-active' : 'module-li'" @click="handleLi(3)">
        <div
          class="module-mask"
        ></div>
        <img class="module-img" src="@/assets/buttonList/web-logo.png" alt="" />
        <span class="module-text">网站</span>
      </div>
      <div :class="active == 4 ? 'module-li module-active' : 'module-li'" @click="handleLi(4)">
        <div
          class="module-mask"
        ></div>
        <img class="module-img" src="@/assets/buttonList/domain-logo.png" alt="" />
        <span class="module-text">域名</span>
      </div>
      <div :class="active == 5 ? 'module-li module-active' : 'module-li'" @click="handleLi(5)">
        <div
          class="module-mask"
        ></div>
        <img class="module-img" src="@/assets/buttonList/email-logo.png" alt="" />
        <span class="module-text">邮件</span>
      </div>
    </div>
    <threeIndex v-show="threeDOrTwoD" :key="threeMapKey" ref="threeMapId"  @handleName="handleName" @closeDialog="closeDialog" :curData="curData" :curNum="curNum"></threeIndex>
    <div class="container-map-box"></div>
    <three-general-world-map-data ref="worldMapRef" v-show="!threeDOrTwoD" :activeScreen="activeScreen" :btnListValue="btnListValue"></three-general-world-map-data>
  </div>
</template>

<script>
import { EventBus } from "@/utils/eventBus";
import threeIndex from "./three/Index.vue";
import {getCountry} from "@/service/dashboard";
import res from "./data.json";
import axios from "axios";
import {countryDict} from "@/theme/dict";
export default {
  name: "threeMap",
  components: {
    threeIndex
  },
  watch: {
    threeDOrTwoD(newVal) {
      if (!newVal) {
        this.$refs.worldMapRef.getData();
      }
    }
  },
  // localStorage.getItem('btnKey')
  data() {
    return {
      threeDOrTwoD: true,
      btnListValue: "all",
      activeScreen: "general",
      threeMapKey: Number(new Date()),
      isShow:false,
      active: 0,
      curNum:{},
      curData: {},
      objList: [],
      objList_2: [],
      rotation: "关闭旋转"
    };
  },
  async created() {
    await this.initData();
  },
  mounted() {
    EventBus.$on("getLocalStoryCallSomeMethod", this.getLocalStory);
    EventBus.$on("changeThreeDToTwoD", this.changeThreeDToTwoD);
    EventBus.$on("changeTwoDMToThreeD", this.changeTwoDMToThreeD);
    this.infoMap();
    setTimeout(() => {
      this.reset();
    }, 3000);
  },
  beforeDestroy() {
    EventBus.$off("changeThreeDToTwoD", this.changeThreeDToTwoD);
    EventBus.$off("changeTwoDMToThreeD", this.changeTwoDMToThreeD);
    EventBus.$off("getLocalStoryCallSomeMethod", this.getLocalStory);
  },
  methods: {
    changeTwoDMToThreeD() {
      this.threeDOrTwoD = true;
    },
    changeThreeDToTwoD() {
      this.threeDOrTwoD = false;
    },
    getLocalStory () {
      this.btnListValue =  localStorage.getItem("btnKey") || "all";
    },
    initData() {
      getCountry().then(res =>{
        this.objList = res.allList;
        this.objList_2 = res.allList;
      });
    },
    handleName(name) {
      // console.log(name, "我是name")
      this.objList.forEach((item) => {
        if (item.name == name) {
          this.curData = item;
        }
      });
      this.curNum = this.curData && this.curData.all;
      this.active = 0;
      this.isShow = true;
    },
    closeDialog(){
      this.isShow = false;
    },
    handleLi(num) {
      // console.log(num, "我是第幾個")
      this.active = num;
      if (num == 0){
        this.curNum = this.curData && this.curData.all;
      } else if (num == 1){
        this.curNum = this.curData && this.curData.pki;
      } else if (num == 2){
        this.curNum = this.curData && this.curData.bgp;
      } else if (num == 3){
        this.curNum = this.curData && this.curData.web;
      } else if (num == 4){
        this.curNum = this.curData && this.curData.dns;
      } else if (num == 5){
        this.curNum = this.curData && this.curData.email;
      }
    },
    // 重置
    reset() {
      this.infoMap(); // 初始化数据
    },
    addLine() {
      // this.$refs.threeMapId.initLine();
      this.$refs.threeMapId.initLine2();
      // console.log(this.$refs.threeMapId.initLine());
    },
    // 地球添加标记点
    infoMap() {
      for (let i = 0; i < this.objList.length; i++) {
        this.$refs.threeMapId.infoMark(this.objList[i]);
      }
    },

    // 移动相机
    cameraPos(item) {
      this.$refs.threeMapId.cameraPos(item);
    },

    // 开启或关闭地球自动旋转
    rotationChange() {
      this.$refs.threeMapId.rotationY = !this.$refs.threeMapId.rotationY;
      this.rotation
        = this.$refs.threeMapId.rotationY === true ? "关闭旋转" : "开启旋转";
      this.$refs.threeMapId.frameDivClose();
    },

    // 添加光柱infoColumn
    columnChange() {
      for (let i = 0; i < this.objList_2.length; i++) {
        this.$refs.threeMapId.infoColumn(this.objList_2[i]);
      }
    },

    // 删除所有标记点
    delAllChange() {
      for (let i = 0; i < this.objList.length; i++) {
        this.$refs.threeMapId.delAll(this.objList[i]);
      }
      for (let i = 0; i < this.objList_2.length; i++) {
        this.$refs.threeMapId.delAll(this.objList_2[i]);
      }
    },

    // 删除指定标记点
    delMarkChange() {
      let item = {
        name: "美国"
      };

      this.$refs.threeMapId.delMark(item);
    }
  }
};
</script>

<style lang="scss">
.home-three-map {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  //background-image: url("./img/back.png");
  opacity: 1;
  background-size: 100% 130%;
  //z-index: 10;
  .module-ul {
    position: absolute;
    bottom: 100px;
    right: 150px;
    width: 192px;
    height: 115px;
    //min-height: 120px;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    margin: 10px;
    justify-content: space-between;
    text-align: center;
    .module-active {
      border-radius: 10px;
      background: linear-gradient(to right, blue 0%, #a4a4d1 100%);
    }
    .module-li {
      width: 45%;
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      color: #fff;
      // opacity: 0.9;
      border-radius: 10px;
      font-weight: bold;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .module-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
        opacity: 0.1;
        border-radius:10px;
      }

      .module-img {
        display: inline-block;
        width: 22px;
        height: 22px;
      }
      .module-text {
        display: inline-block;
        margin-left: 10px;
        font-size: 14px;
        font-weight: 700;
        color: #FFF;
        // vertical-align: middle;
      }
    }
  }
  .rightMain {
    position: absolute;
    right: 0;
    width: 300px;
    height: 100%;
    z-index: 100;
    padding: 10px;
    box-sizing: border-box;
    color: white;
    background-color: rgba(255, 255, 255, 0.2);
    .title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .cont {
      height: 150px;
      ul {
        padding: 0;
        margin-bottom: 0;
        li {
          list-style: none;
          float: left;
          width: 33.33%;
          padding: 10px 0;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
          &:hover {
            color: aquamarine;
          }
        }
      }
    }
  }
}
</style>
